// Position badge color system - no brand orange on TE to avoid CTA collision
// QB=red(urgency), RB=field-green, WR=sky-blue, TE=amber(distinct from pylon-orange), K/DEF=neutral
const POSITION_STYLES = {
  QB:  "bg-[#E03030] text-white",
  RB:  "bg-[#00C853] text-[#111111]",
  WR:  "bg-[#007AFF] text-white",
  TE:  "bg-[#C97000] text-white",   // amber - distinct from #FF6B00 pylon-orange
  K:   "bg-[#505050] text-[#F5F5F5]",
  DEF: "bg-[#505050] text-[#F5F5F5]",
};

export default function PositionBadge({ position, size = "sm" }) {
  const style   = POSITION_STYLES[position] || "bg-[#333] text-[#A0A0A0]";
  const sizeClass = size === "lg" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span className={`font-display font-black uppercase tracking-wider rounded ${style} ${sizeClass} shrink-0`}>
      {position}
    </span>
  );
}
